import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Link } from '../../component-link';
import { forwardRef } from 'react';
export const RatingInformationLink = forwardRef((props, ref) => {
    return _jsx(Link, { variant: "neutral", size: "sm", ...props, ref: ref });
});
RatingInformationLink.displayName = 'RatingInformationLink';
